export default (theme) => ({
    root: {
        width: '100%',
        '& [class*="navPrev"]': {
            background: `linear-gradient(to right, ${theme.colors.background.utility025} 60%, transparent 100%)`,
        },
        '& [class*="navNext"]': {
            background: `linear-gradient(to left, ${theme.colors.background.utility025} 60%, transparent 100%)`,
        },
    },
});
